import React from "react";
import {Button} from "@mui/material";


const ButtonSecondary = (props) => {
    return (
        <Button {...props} variant="contained" className={`comp-button button-secondary-new ${props.className ? props.className : ''}`} />
    );
}
export {ButtonSecondary};